import {
  FEATURE_LIMITS,
  getFeatureLimitedAccount,
  getFeatureLimitsData,
  getFeatureLimitsLabel,
} from 'src/data/featureLimits';
import { getCustomerPlan } from 'src/data/subscription';
import { useCustomerMaxMembers } from 'src/store/customerMember';

import { useCurrentCustomer } from './useCurrentCustomer';

/**
 * Feature limits data
 * @typedef FeatureLimitData
 * @type {object}
 * @property {number} limit - feature limit
 * @property {number} currentCount - current feature usage
 * @property {object} [limitedAccountData] - limited account data
 * @property {string} label - feature label
 * @property {string} plan - customer plan
 */

/**
 * Get the feature limits data for the given feature limit
 *
 * HINT: if you don't need this data during render phase (and don't need "membersPerCustomer" value),
 *       then it is better to use `CustomerStore.featureLimitExceeded` action.
 * @param {FEATURE_LIMITS} featureLimit - feature
 * @returns {FeatureLimitData}
 */
export const useCustomFeatureLimitsData = (featureLimit) => {
  const currentCustomer = useCurrentCustomer();
  const plan = getCustomerPlan(currentCustomer);
  const label = getFeatureLimitsLabel(featureLimit);

  // Special case - user limits
  const { usersCount, maxMembers } = useCustomerMaxMembers();

  if (featureLimit === FEATURE_LIMITS.membersPerCustomer) {
    return { currentCount: usersCount, limit: maxMembers, label };
  }

  const featureLimitsData = getFeatureLimitsData(currentCustomer, featureLimit);
  const limitedAccountData = getFeatureLimitedAccount(currentCustomer);

  return {
    limit: featureLimitsData?.limit,
    currentCount: featureLimitsData?.currentCount,
    limitedAccountData,
    label,
    plan, // TODO: "plan" looks out of place here, we have other ways to get it
  };
};
